import { render, staticRenderFns } from "./SewipPatients.vue?vue&type=template&id=1c437807&scoped=true&lang=pug&"
import script from "./SewipPatients.vue?vue&type=script&lang=ts&"
export * from "./SewipPatients.vue?vue&type=script&lang=ts&"
import style0 from "./SewipPatients.vue?vue&type=style&index=0&id=1c437807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c437807",
  null
  
)

export default component.exports